import React, { useState, useEffect, useContext } from "react";
import { BrowserRouter as Routers } from "react-router-dom";
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  createHttpLink,
} from "@apollo/client";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { setContext } from "@apollo/client/link/context";
import { createTheme } from "@mui/material/styles";
//Srcs
import "./App.css";
import Router from "./routes";
import { AuthContext } from "./Context/AuthContext";
import AlertMessage from "./Components/AlertMessage/AlertMessage";

function App() {
  const { state } = useContext(AuthContext);
  const { user } = state;

  // =========================== Set token ===============================
  const [token, setToken] = useState(
    JSON.parse(window.localStorage.getItem("token"))
  );

  useEffect(() => {
    let userToken = JSON.parse(window.localStorage.getItem("token"));
    if (userToken) {
      setToken(userToken);
      return;
    }

    if (user?.token) {
      setToken(user?.token);
      window.localStorage.setItem("token", JSON.stringify(user?.token));
    } else {
      setToken("");
    }
  }, [user]);

  //============================ CREATE THEME ==============================
  const theme = React.useMemo(
    () =>
      createTheme({
        palette: {
          background: {
            default: "#EBEDEF",
          },
        },
        typography: {
          fontFamily: ["Century Gothic", "Siemreap"].join(","),
        },
      }),
    []
  );

  //====================== Connect Apollo Client =========================
  const httpLink = createHttpLink({
    // uri: "http://192.168.2.11:4300/graphql",
    uri: process.env.REACT_APP_END_POINT,
  });

  const authLink = setContext((_, { headers }) => {
    return {
      headers: {
        ...headers,
        authorization: token,
      },
    };
  });

  const client = new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache(),
  });

  return (
    <ApolloProvider client={client}>
      <ThemeProvider theme={theme}>
        <Routers>
          <Router />
        </Routers>
        <CssBaseline />
      </ThemeProvider>
      <AlertMessage />
    </ApolloProvider>
  );
}

export default App;
